import {produce} from 'immer'
import type {StateCreator} from 'zustand'
import type {LayoutCurrentUser} from '../LayoutStore'
import type {PullRequestNotices} from '../../page-data/payloads/notices'

export interface LayoutCurrentUserSlice {
  layoutCurrentUser: LayoutCurrentUser

  layoutCurrentUserActions: {
    dismissNotice: (notice: PullRequestNotices) => void
  }
}

export interface LayoutCurrentUserSliceOpts {
  layoutCurrentUser: LayoutCurrentUser
}

export const createLayoutCurrentUserSlice =
  ({
    layoutCurrentUser,
  }: LayoutCurrentUserSliceOpts): StateCreator<
    LayoutCurrentUserSlice,
    [['zustand/devtools', never]],
    [],
    LayoutCurrentUserSlice
  > =>
  set => ({
    layoutCurrentUser: {
      canComment: layoutCurrentUser.canComment,
      canEditTitle: layoutCurrentUser.canEditTitle,
      canFixWithCopilot: layoutCurrentUser.canFixWithCopilot,
      notices: layoutCurrentUser.notices ?? [],
    },
    layoutCurrentUserActions: {
      dismissNotice: notice => {
        set(
          produce((state: LayoutCurrentUserSlice) => {
            const userNotice = state.layoutCurrentUser.notices.find(currentNotice => currentNotice.name === notice)
            if (userNotice) {
              userNotice.dismissed = true
            }
          }),
          undefined,
          'dismissNotice',
        )
      },
    },
  })
